import { UserUpdatePage } from '@/features/access/pages/user/UserUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/user/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_users.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UserUpdatePage,
})
